import { Clock, Loader2 } from "lucide-react";

/** Lo que pasa con el cruce de la obra mientras no hay veredicto: corriendo o esperando sus bases. */
export function QualificationStateNote({
  state,
}: {
  state?: "ANALYZING" | "WAITING_BASES" | null;
}) {
  if (state === "ANALYZING") {
    return (
      <div className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-sky-700 dark:text-sky-300">
        <Loader2 className="size-3.5 animate-spin" />
        Analizando sus requisitos con tus documentos…
      </div>
    );
  }
  if (state === "WAITING_BASES") {
    // El correo todavía no existe: es la promesa que decidió Abel (ver la spec del 10-oct).
    return (
      <div className="mt-2 flex items-center gap-1.5 text-xs text-slate-500">
        <Clock className="size-3.5" />
        Esperando sus bases: te enviaremos el informe por correo cuando las leamos.
      </div>
    );
  }
  return null;
}
